/**
 * External dependencies
 */
import { combineReducers } from 'redux';

/**
 * Internal dependencies
 */
import { START_OPERATION_DETAILS_MODAL } from 'state/action-types';

import { createReducer } from 'state/utils';

export const operationId = createReducer(null, {
    [START_OPERATION_DETAILS_MODAL]: (state, { payload }) => payload.operationId,
});

export default combineReducers({
    operationId,
});
